require('../../modules/es.array.iterator');

module.exports = require('../../internals/entry-unbind')('Array', 'values');
